import StyleClassNamesBuilder from '../../../styles/helpers/StyleClassNamesBuilder';
import { StyleSizeType } from '../../../styles/enums';

export const GridSizeStylesProps = {
  props: {
    size: {
      required: true,
      type: String,
    },
  },
};

export const GridSizeStylesMethods = {
  methods: {
    getClassNamesBuilderWithSizeClassNames(rootClassName) {
      return new StyleClassNamesBuilder(rootClassName)
        .addConditionClassNames(Object.values(StyleSizeType), this.size);
    },
  },
};

export default {
  GridSizeStylesProps,
  GridSizeStylesMethods,
};
